import React from 'react';

import theme from '../../../style/theme';
import {getPriceCents, getPriceDollars} from '../../../utils/text';

import BmSnsBadge, {DEFAULT_BADGE_SIZE} from './BmSnsBadge';
import HbTcBadge from './HbTcBadge';
import {SvgBadgeComponent} from './types';

type BadgeProps = {
  price: string;
  text: string;
  size?: number;
};

const BadgeComponent: SvgBadgeComponent =
  theme.size.badge.type === 'circle' ? HbTcBadge : BmSnsBadge;

export const Badge = ({price, text, size = DEFAULT_BADGE_SIZE}: BadgeProps) => {
  let priceDollars = '0';
  let priceCents = '00';

  if (price.includes('c')) {
    priceCents = price.replace('c', '');
    if (priceCents.length === 1) {
      priceCents = '0' + priceCents;
    }
  } else {
    priceDollars = getPriceDollars(price);
    priceCents = getPriceCents(price);
  }

  return (
    <BadgeComponent
      price={price}
      priceDollars={priceDollars}
      priceCents={priceCents}
      text={text}
      size={size}
    />
  );
};
